import { render, staticRenderFns } from "./BuyHealth.vue?vue&type=template&id=c779ed96&"
import script from "./BuyHealth.vue?vue&type=script&lang=js&"
export * from "./BuyHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports